<template>
  <div class="container">
    <div class="row justify-content-center mt-5">
      <div class="col col-lg-9 col-xl-8">
        <div class="row">
          <div class="col">
            <h4 v-if="feedback.body" class="text-center body p-5" v-html="feedback.body"></h4>
          </div>
        </div>
        <div v-if="hasResponses" class="row justify-content-center">
          <div class="form-group col col-sm-3" v-for="response in feedback.responses" :key="response.value">
            <button type="button" class="btn btn-block text-capitalize" @click="emitResponse(response.value)">
              {{ response.text }}
            </button>
          </div>
        </div>
        <div v-if="hasTimeout" class="row justify-content-around my-3 text-center">
          <div class="col">
            <div class="progress" style="height: 16px;">
              <div
                class="progress-bar progress-bar-striped"
                role="progressbar"
                :class="progressBarColor"
                :style="{ width: progressBarPercent + '%' }"
                :aria-valuenow="progressBarPercent"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
            <h5 class="mt-4"><fa icon="clock" class="mr-2" />{{ secondsLeft }} {{ $t("seconds") }}</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    feedback: {
      body: String,
      timeoutInSeconds: Number,
      responses: Array,
    },
    progressBarDelayInMilliseconds: {
      type: Number,
      default: 1000,
    },
  },
  data() {
    return {
      isLoading: false,
      millisecondsLeft: null,
      countdownInterval: null,
      startIntervalTimeout: null,
    };
  },
  computed: {
    hasResponses() {
      return this.feedback.responses && this.feedback.responses.length > 0;
    },
    hasTimeout() {
      return this.feedback.timeoutInSeconds && this.feedback.timeoutInSeconds > 0;
    },
    millisecondsAllowed() {
      // todo: handle infinite refresh for infinite time
      return this.feedback.timeoutInSeconds * 1000;
    },
    secondsLeft() {
      return Math.ceil(this.millisecondsLeft / 1000);
    },
    progressBarPercent() {
      return (this.millisecondsLeft / this.millisecondsAllowed) * 100;
    },
    progressBarColor() {
      if (this.progressBarPercent < 34) return "bg-danger";
      if (this.progressBarPercent < 67) return "bg-warning";
      return "bg-success";
    },
  },
  watch: {
    feedback() {
      this.reset();
    },
  },
  mounted() {
    this.reset();
  },
  methods: {
    reset() {
      this.isLoading = false;
      this.millisecondsLeft = this.millisecondsAllowed;
      if (this.countdownInterval) clearInterval(this.countdownInterval);
      this.startIntervalTimeout = setTimeout(this.startInterval, this.progressBarDelayInMilliseconds); // allows progress animation to "refill"
    },
    startInterval() {
      this.countdownInterval = setInterval(this.onInterval, 100, 100);
    },
    onInterval(interval) {
      if (!this.hasTimeout) return;
      if (this.millisecondsLeft === 0) return;
      this.millisecondsLeft -= interval;
      this.millisecondsLeft = Math.max(this.millisecondsLeft, 0);
      if (this.millisecondsLeft === 0) {
        this.isLoading = true;
        this.emitResponse("timeout");
      }
    },
    emitResponse(value) {
      this.isLoading = true;
      if (this.startIntervalTimeout) clearTimeout(this.startIntervalTimeout);
      if (this.countdownInterval) clearInterval(this.countdownInterval);
      this.$emit("response", value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/base.scss";

.body {
  @extend .p-3;
  @extend .mb-4;
  @extend .alert;
  @extend .alert-secondary;
  @extend .bg-white;

  max-height: 500px;
  overflow-y: auto;
}
</style>
